import React from 'react';
import Navbar from '../../../components/Navbar';
import Footer from '../../../components/Footer';
import Copyright from '../../../components/Copyright';
import AIinHealthcare from './AIinHealthcare';

export default function Blog() {
  return (
    <>
        <Navbar />
        <AIinHealthcare />
        <Footer />
        <Copyright />
    </>
  )
}